import { render } from "./AddLevel.vue?vue&type=template&id=5b8c7b5e&scoped=true"
import script from "./AddLevel.vue?vue&type=script&lang=js"
export * from "./AddLevel.vue?vue&type=script&lang=js"

import "./AddLevel.vue?vue&type=style&index=0&id=5b8c7b5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b8c7b5e"]])

export default __exports__